import { Badge } from '@workspace/ui/components/badge'
import { History } from 'lucide-react'
import type { PitchHistoryEntry } from '../types'

export function PreviousPitchesSection({ pitches }: { pitches: PitchHistoryEntry[] }) {
  const latest = pitches[0]
  if (!latest) return null

  return (
    <div className="px-5 py-2.5">
      <div className="flex items-center gap-2">
        <History className="size-3.5 text-muted-foreground" />
        <span className="text-xs font-medium text-foreground">Last pitch</span>
      </div>
      <div className="mt-1.5 flex items-center gap-2">
        <span className="text-xs text-muted-foreground">{latest.date}</span>
        <span className="text-xs font-medium text-foreground">Score {latest.overallScore}</span>
        <Badge variant="secondary" size="sm">
          {latest.readiness}
        </Badge>
      </div>
    </div>
  )
}
